import styled from 'styled-components';

export const NewsPageContainer = styled.div``;
